module.exports = __webpack_public_path__ + "img/1542792309.a9922684.jpg";